import theme from '../../theme';
import { Checkbox, CheckboxProps, styled } from '@mui/material';

export const CheckboxStyled = styled(Checkbox)<CheckboxProps>(() => ({
  '&.MuiCheckbox-root': {
    color: theme.palette.secondary.main,
    '&.Mui-checked': {
      color: theme.palette.tertiary.main,
    },
  },
  '&.MuiCheckbox-colorPrimary': {
    color: theme.palette.secondary.main,
    '&.Mui-checked': {
      color: theme.palette.primary.main,
    },
  },
  '&.MuiCheckbox-colorSecondary': {
    color: theme.palette.secondary.main,
    '&.Mui-checked': {
      color: theme.palette.secondary.main,
    },
  },
}));
